export const selectCenterId = state => state.auth.selectedCenter.id

export const selectConfig = state => state.auth.config
